export default __webpack_public_path__ + "static/media/WAS0333.34I-41666_-24931_0.4566b047.jpg";